import { Banner } from '@figma/fpl-components';
import { FF_FPL_MIGRATION } from '@/consts/featureFlags';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { Alert } from '@/UI/Alert/Alert';
import { WarningTriangleIcon } from '@/UI/Icons/WarningTriangleIcon';
import { Tooltip } from '@/UI/Tooltip/Tooltip';

export function RunErrorBanner({ message }: { message: string }) {
  const isFpl = useFeatureFlag(FF_FPL_MIGRATION).value === true;

  if (isFpl) {
    return (
      <Banner.Inset variant="danger" data-testid="fpl-run-error-banner">
        <Banner.Message>{message}</Banner.Message>
      </Banner.Inset>
    );
  }

  return (
    <Tooltip title={message} placement="top">
      <Alert
        severity="error"
        sx={{
          maxWidth: '100%',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          fontSize: '12px',
          alignContent: 'center',
          justifyContent: 'center',
          fontWeight: 'regular',
        }}
        slotProps={{ icon: { sx: { fontSize: 'inherit' } } }}
        icon={<WarningTriangleIcon width={16} height={16} />}
      >
        {message}
      </Alert>
    </Tooltip>
  );
}
